import { FormProvider, useForm } from 'react-hook-form';
import ApplyFilter from '../../../components/applyFilter';
import * as yup from 'yup';
import { DatePickerController } from '../../../components';

export const formSchema = yup.object({
  startDate: yup.date().required('Start Date is required'),
  endDate: yup.date().required('End Date is required'),
});

export type TFilterForm = yup.InferType<typeof formSchema>;

export type TFilterProps = {
  filters: TFilterForm;
  setFilters: React.Dispatch<
    React.SetStateAction<TFilterForm>
  >;
};

export const Filters: React.FC<TFilterProps> = ({
  filters,
  setFilters,
}) => {
  const form = useForm<TFilterForm>({
    mode: 'onTouched',
    defaultValues: filters,
  });

  const {
    control,
    formState: { errors },
    watch,
  } = form;

  const onFilterDrawerOpen = () => {
    Object.keys(filters).forEach((key) => {
      const k = key as keyof TFilterForm;
      form.setValue(k, filters[k]);
    });
  };

  return (
    <div className="filters">
      <FormProvider {...form}>
        <ApplyFilter
          executeSubmitEvent={() =>
            setFilters({
              startDate: watch('startDate'),
              endDate: watch('endDate'),
            })
          }
          onFilterDrawerOpen={onFilterDrawerOpen}>
          <form className="filter-form">
            <DatePickerController
              label="Payment start Date"
              control={control}
              name="startDate"
              error={errors.startDate?.message}
              selectsStart
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
            <DatePickerController
              label="Payment end Date"
              control={control}
              name="endDate"
              error={errors.endDate?.message}
              selectsEnd
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
          </form>
        </ApplyFilter>
      </FormProvider>
    </div>
  );
};
